"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { PresentationRoutedPage } from './deskUi/PresentationRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function PresentationSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={PresentationRoutedPage} Loading={MsgDeskLoading} />
}
